import { fn } from 'storybook/test';

import type { Meta, StoryFn } from '@storybook/react';
import type { ControlsButtonProps } from './ControlsButton';

import { ControlsButton } from './ControlsButton';

import { Icons } from 'components/Icon/icons';
import { Periods } from 'components/Periods';

const iconNames = Object.keys(Icons) as (keyof typeof Icons)[];

const codeString =
  '<ControlsButton type={radio or checkbox} label={} value={} prefix={} tooltip={} forceSquared={}isChecked={} variant={} disabled={} notValid={} onSetValue={} key={} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/ControlsButton',
  component: ControlsButton,
  argTypes: {
    label: {
      control: 'text',
    },
    value: {
      control: 'string',
    },
    iconName: {
      control: { type: 'select' },
      options: iconNames,
    },
    forceSquared: {
      control: 'boolean',
    },
    isChecked: {
      control: 'boolean',
    },
    disabled: {
      control: 'boolean',
    },
    onSetValue: {
      table: {
        disable: true,
      },
    },
  },
  parameters: {
    inspectComponent: ControlsButton,
    codeString: codeString,
  },
} as Meta<ControlsButtonProps>;

const Template: StoryFn<ControlsButtonProps> = (args) => <ControlsButton {...args} />;

export const ControlsButtonExample = Template.bind({});
ControlsButtonExample.args = {
  type: 'checkbox',
  label: '1.2',
  value: '1.2',
  forceSquared: true,
  onSetValue: fn(),
};

export const WithPrefix = Template.bind({});
WithPrefix.args = {
  type: 'checkbox',
  label: '1.3',
  value: '1.3',
  prefix: '13',
  onSetValue: fn(),
};

export const WithIcon = Template.bind({});
WithIcon.args = {
  type: 'checkbox',
  label: '2.1',
  value: '2.1',
  iconName: 'AcademicCap',
  onSetValue: fn(),
};

export const WithTooltip = Template.bind({});
WithTooltip.args = {
  type: 'checkbox',
  label: '5',
  value: '5',
  prefix: '40',
  tooltip: (
    <>
      15 dec - 19 dec
      <br />
      2025
    </>
  ),
  tooltipPosition: 'center',
  onSetValue: fn(),
};

export const WithComplexLabel = Template.bind({});
WithComplexLabel.args = {
  type: 'checkbox',
  label: (
    <Periods
      periods={[
        {
          id: '2023P1',
          number: 1,
          semesterNumber: 1,
          periodInSemester: 1,
        },
        {
          id: '2023P2',
          number: 2,
          semesterNumber: 1,
          periodInSemester: 2,
        },
        {
          id: '2023P3',
          number: 3,
          semesterNumber: 1,
          periodInSemester: 3,
        },
        {
          id: '2023P5',
          number: 5,
          semesterNumber: 2,
          periodInSemester: 2,
        },
        {
          id: '2023P7',
          number: 7,
          semesterNumber: 3,
          periodInSemester: 1,
        },
      ]}
    />
  ),
  value: '5',
  onSetValue: fn(),
};
